import React from 'react'
import { useAddToHomescreenPrompt } from 'lib/hooks/useAddToHomescreenPrompt'

export const AddToHomePromptContext = React.createContext()

const AddToHomePrompt = ({ children }) => {
    const [prompt, promptToInstall] = useAddToHomescreenPrompt()
    return (
        <AddToHomePromptContext.Provider
            value={{ prompt, promptToInstall }}
        >
            {children}
        </AddToHomePromptContext.Provider>
    )
}

export default AddToHomePrompt
